import axios from 'axios'
import authHeader from './auth-header'

class EnrollmentImportService {
  analyze (file) {
    const data = new FormData()
    data.append('file', file)

    return axios.post(
      process.env.VUE_APP_API_URL + 'enrollment-imports/analyze',
      data,
      { headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' } }
    )
  }

  get (uuid) {
    return axios.get(
      process.env.VUE_APP_API_URL + `enrollment-imports/${uuid}`,
      { headers: authHeader(), timeout: 30000 }
    )
  }

  downloadFeedback (uuid) {
    return axios.get(
      process.env.VUE_APP_API_URL + `enrollment-imports/${uuid}/feedback`,
      { headers: authHeader(), responseType: 'blob' }
    )
  }

  execute (uuid, payload) {
    return axios.post(
      process.env.VUE_APP_API_URL + `enrollment-imports/${uuid}/execute`,
      payload,
      { headers: authHeader(), timeout: 30000 }
    )
  }
}

export default new EnrollmentImportService()
